import { Dialog, DialogTitle, DialogContent, Typography, DialogActions, Button } from "@mui/material"

interface InfoProps {
    open: boolean,
    onClose: () => void
    // onConfirm: () => void
}

export default function InfoPersonalDataDialog({ open, onClose }: InfoProps) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="confirm-dialog-title"
            aria-describedby="confirm-dialog-description"
            sx={{
                '& .MuiDialog-paper': {
                    borderRadius: 8, // Makes the dialog more rounded
                    maxWidth: 400,
                    p: 1
                }
            }}
        >
            <DialogTitle >
                Integritetspolicy
            </DialogTitle>
            <DialogContent>
                <div
                    style={{ display: 'flex', flexDirection: 'column', gap: 10, alignItems: 'flex-start', paddingLeft: 2 }}
                // sx={{paddingLeft:1}}

                >
                    <Typography variant='h6'>1. Vilka uppgifter som lagras</Typography>
                    <Typography variant='body2'>Jag lagrar information som du själv anger i appen, såsom namn, telefonnummer samt innehåll i dina inköpslistor.</Typography>
                    <Typography variant='h6'>2. Hur uppgifterna används</Typography>
                    <Typography variant='body2'>Uppgifterna används för att tillhandahålla appens funktioner, inklusive att hantera inköpslistor och möjliggöra delning via WhatsApp (där meddelandet genereras lokalt i appen och skickas av dig).</Typography>
                    <Typography variant='h6'>3. Åtkomst till uppgifter</Typography>
                    <Typography variant='body2'>Jag kan i begränsad omfattning få tillgång till uppgifterna för underhåll, felsökning och förbättring av tjänsten. Uppgifterna används inte för andra ändamål.</Typography>
                    <Typography variant='h6'>4. Lagring av data</Typography>
                    <Typography variant='body2'>Uppgifterna lagras hos tjänsteleverantören Supabase i enlighet med gällande dataskyddslagstiftning.</Typography>
                    <Typography variant='h6'>5. Dina rättigheter</Typography>
                    <Typography variant='body2'>Du har rätt att begära tillgång till eller radering av dina uppgifter. Kontakta mig vid frågor kring detta.</Typography>
                    <Typography variant='h6'>6. Kontakt</Typography>
                    <Typography variant='body2'>Vid frågor om denna policy, kontakta mig via ida@bergenholtz.se.</Typography>
                </div>

            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    Ok
                </Button>
                {/* <Button variant="contained" onClick={onConfirm} autoFocus>
                    <AddOutlined />
                    Skapa lista
                </Button> */}
            </DialogActions>
        </Dialog>
    )
}